export const preventTouchEvents = (canvas) => {
    canvas.addEventListener('touchstart', evt => evt.preventDefault());
    canvas.addEventListener('touchmove', evt => evt.preventDefault());
    canvas.addEventListener('touchend', evt => evt.preventDefault());
    canvas.addEventListener('touchcancel', evt => evt.preventDefault());
};
